import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "actionMetadata", "actionId"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import ClassicCopyCompanyPropertyActionMetadata from 'automation-ui-action-features/actions/classic-copy-company-property/records/ClassicCopyCompanyPropertyActionMetadata';
import ClassicCopyCompanyPropertyActionDetail from 'automation-ui-action-features/actions/classic-copy-company-property/ClassicCopyCompanyPropertyActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class ClassicCopyCompanyPropertyActionCard extends Component {
  render() {
    const _this$props = this.props,
      {
        getHeaderTitle,
        actionMetadata,
        actionId
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
      headerTitle: getHeaderTitle({
        actionId
      }),
      content: /*#__PURE__*/_jsx(ClassicCopyCompanyPropertyActionDetail, {
        actionMetadata: actionMetadata
      })
    }));
  }
}
ClassicCopyCompanyPropertyActionCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(ClassicCopyCompanyPropertyActionMetadata).isRequired,
  getHeaderTitle: PropTypes.func.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default ClassicCopyCompanyPropertyActionCard;